/**
 * User role types
 *
 * Note: Location roles use hyphens (e.g., 'location-admin') to match
 * the role slugs stored in auth-service database.
 */
export const ROLES = [
    'pb:super', // Olympus super-admin user representation
    'brand:admin',
    'brand:kitchen',
    'location-admin',
    'location-manager',
    'location-employee',
    'olo:customer', // Online ordering customer role
    'olo:guest', // Online ordering guest role
];
/**
 * Resource types for permission slugs.
 * NOTE: This list must be kept in sync with similar lists found in other files.
 * See apps/auth-service/README.md ("Important: Update resource constants...")
 * for more detail.
 */
export const RESOURCES = [
    'actions',
    'app-store-maintenance',
    'atlas.order',
    'ava',
    'billing',
    'brand',
    'brand.theme',
    'career',
    'career.applications',
    'career.jobs',
    'cart',
    'cash-drawer.reconciliation',
    'cash-drawer.session',
    'catering-settings',
    'checkout-settings',
    'coupon',
    'customer',
    'customer-io-sync',
    'customer.cross-brand',
    'customer.subscriptions',
    'delivery',
    'delivery.settings',
    'device',
    'dispute',
    'domain',
    'employment',
    'employment.jobs',
    'employment.shiftEvents',
    'employment.shifts',
    'enrichment.business',
    'event',
    'fee-settings',
    'form',
    'form.submission',
    'funnel',
    'funnel.page',
    'funnel.redirect',
    'generator',
    'gift-card',
    'gift-card.balance',
    'gift-card.charge',
    'gift-card.order',
    'google-search-console',
    'grader.report',
    'grader.screenshot',
    'grader.token',
    'growth.comparison-evidence',
    'growth.hero-video-upload',
    'growth.social-generation-context',
    'growth.temporal-state',
    'heartbeat',
    'heartbeat.kds',
    'heartbeat.location',
    'inbox.message',
    'inbox.thread',
    'inhouse-delivery.assignment',
    'inhouse-delivery.job',
    'integrations',
    'job',
    'job-application',
    'kds',
    'keyword',
    'legal',
    'legal.acceptance',
    'legal.agreement',
    'lifecycle.event',
    'lifecycle.workflow',
    'listing',
    'listing.scan',
    'listing.subscription',
    'location',
    'location.special-hours',
    'marketing',
    'marketing.admin',
    'marketing.block',
    'marketing.campaign',
    'marketing.delivery',
    'marketing.reporting',
    'marketing.status',
    'marketing.template-override',
    'marketplace',
    'menu',
    'menu.availability',
    'menu.likes',
    'mobile-app',
    'preflight-runtime-policy',
    'nacho',
    'onboarding',
    'order',
    'order.charge',
    'order.fulfillment',
    'order.payment',
    'order.prep-time',
    'order.refund',
    'order.status',
    'order.void',
    'ownership-group',
    'partner-referral',
    'payment-account',
    'payout',
    'phone-order.call',
    'phone-order.session-report',
    'physical-media',
    'qualification.lead',
    'relay',
    'reports',
    'reports.reverse-etl',
    'review',
    'sales.custom-pricing',
    'scout.job',
    'scout.media',
    'scout.pipeline',
    'scout.research',
    'scout.website',
    'seo',
    'seo.keyword',
    'session',
    'smart-coupon',
    'snapshot',
    'square.comm-ticket',
    'station',
    'station.message',
    'station.telemetry',
    'system.job',
    'template',
    'template.email',
    'template.email-section',
    'template.sms',
    'template.sms-section',
    'user',
    'user.notifications',
    'user.password',
    'user.staff',
    'virtual-card',
    'voice',
    'voice.phone-tree',
    'warehouse-fulfillment',
    'warehouse.event',
    'warehouse.job',
    'warehouse.order',
    'warehouse.return',
    'webhook',
    'webhook.otter',
];
/**
 * Operation types
 */
export const OPERATIONS = [
    'read',
    'update',
    'edit', // deprecated
    'delete',
    'create',
    'manage',
    '*',
];
//# sourceMappingURL=constants.js.map